import { useEffect } from 'react';
import axios from 'axios';
import Loading from '../../Components/Loading';
import { useHistory } from "react-router";
import { useUser } from '../../providers/UserContext';

export const GoogleCallback = () => {
    const history = useHistory()
    const { Login } = useUser();

    useEffect(() => {
        const exchangeCodeForToken = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');

            history.push('/')

            // Obtido o token de autorização, manda para o servidro fazer a tratativa e retornar os dados.
            // axios.post('/api/sessions/oauth/google', { code }).then(response => {
            //     Login(response.data);
            //     if (option === false) {
            //         history.push("/home")
            //     } else {
            //         history.push("/mapMaketplace")
            //     }
            // });


        };

        exchangeCodeForToken();
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Loading />
        </div>
    );
};

export default GoogleCallback;
